"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const get_value_1 = require("./get-value");
const objects_1 = require("../../type-checking/objects");
const typing_1 = require("../../type-checking/typing");
const primitives_1 = require("../../type-checking/primitives");
const address_1 = require("../../type-checking/address");
class AddressFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, objects_1.isValidObjectValue)(fieldValue, {
                location_country: (0, typing_1.Optional)(primitives_1.isStringValue),
                location_country_code: (0, typing_1.Optional)(primitives_1.isStringValue),
                location_state: (0, typing_1.Optional)(primitives_1.isStringValue),
                location_city: (0, typing_1.Optional)(primitives_1.isStringValue),
                location_zip: (0, typing_1.Optional)(primitives_1.isStringValue),
                location_address: (0, typing_1.Optional)(primitives_1.isStringValue),
                location_address2: (0, typing_1.Optional)(primitives_1.isStringValue),
                location_latitude: (0, typing_1.Optional)((0, typing_1.Union)(primitives_1.isStringValue, primitives_1.isNumberValue)),
                location_longitude: (0, typing_1.Optional)((0, typing_1.Union)(primitives_1.isStringValue, primitives_1.isNumberValue)),
                location_point: (0, typing_1.Optional)(address_1.isLocationPointValue),
                sys_root: (0, typing_1.Optional)(primitives_1.isStringValue),
            });
        };
        this.getEmptyValue = () => (0, get_value_1.getAddressFieldEmptyValue)();
        this.isOptimizedFieldValue = (fieldValue) => {
            return (0, objects_1.isValidObjectValue)(fieldValue, {
                country: (0, typing_1.Optional)(primitives_1.isStringValue),
                state: (0, typing_1.Optional)(primitives_1.isStringValue),
                city: (0, typing_1.Optional)(primitives_1.isStringValue),
                zip: (0, typing_1.Optional)(primitives_1.isStringValue),
                address: (0, typing_1.Optional)(primitives_1.isStringValue),
                address2: (0, typing_1.Optional)(primitives_1.isStringValue),
                lat: (0, typing_1.Optional)((0, typing_1.Union)(primitives_1.isStringValue, primitives_1.isNumberValue)),
                long: (0, typing_1.Optional)((0, typing_1.Union)(primitives_1.isStringValue, primitives_1.isNumberValue)),
            });
        };
        this.getValueFromOptimized = (fieldValue) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return {
                location_address: (_a = fieldValue.address) !== null && _a !== void 0 ? _a : "",
                location_address2: (_b = fieldValue.address2) !== null && _b !== void 0 ? _b : "",
                location_zip: (_c = fieldValue.zip) !== null && _c !== void 0 ? _c : "",
                location_country: (_d = fieldValue.country) !== null && _d !== void 0 ? _d : "",
                location_state: (_e = fieldValue.state) !== null && _e !== void 0 ? _e : "",
                location_city: (_f = fieldValue.city) !== null && _f !== void 0 ? _f : "",
                location_longitude: (_g = fieldValue.long) !== null && _g !== void 0 ? _g : "",
                location_latitude: (_h = fieldValue.lat) !== null && _h !== void 0 ? _h : "",
                sys_root: (0, get_value_1.generateFullAddress)(fieldValue),
            };
        };
    }
}
exports.AddressFieldValueGetter = AddressFieldValueGetter;
